module.exports = __webpack_public_path__ + "img/20191118160644360截图20191118155350333.5ab79a1a.jpg";